const topics = [
  { icon: 'ri-tv-line', label: '热播剧集', desc: '同步卫视热播', color: 'primary' },
  { icon: 'ri-movie-2-line', label: '高分电影', desc: '豆瓣精选佳作', color: 'accent' },
  { icon: 'ri-emotion-line', label: '动漫番剧', desc: '热门新番连载', color: 'primary' },
  { icon: 'ri-live-line', label: '综艺娱乐', desc: '热门综艺更新', color: 'accent' },
  { icon: 'ri-building-2-line', label: '港剧经典', desc: 'TVB必看神作', color: 'primary' },
  { icon: 'ri-earth-line', label: '韩剧精选', desc: '高分韩剧在线', color: 'accent' },
  { icon: 'ri-slideshow-2-line', label: '纪录大片', desc: '探索世界之美', color: 'primary' },
];

export default function IndexSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.querySelector('#cards');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            七大影视分类，精准找到你想看的每一部好剧
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {topics.map((topic) => {
            const isPrimary = topic.color === 'primary';
            return (
              <a
                key={topic.label}
                href="#cards"
                onClick={handleClick}
                className={`group flex flex-col items-center text-center p-5 md:p-6 rounded-xl transition-all duration-300 cursor-pointer ${
                  isPrimary
                    ? 'bg-background-50 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200/60'
                    : 'bg-background-50 hover:bg-accent-50 border border-background-200/60 hover:border-accent-200/60'
                }`}
              >
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full mb-3 transition-colors ${
                    isPrimary
                      ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50'
                      : 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50'
                  }`}
                >
                  <i className={`${topic.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1 whitespace-nowrap">
                  {topic.label}
                </h3>
                <p className="text-xs text-foreground-500 whitespace-nowrap">{topic.desc}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}